/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ReduxStore } from '../../Constants/App';

interface IJobSelectionState {
  rowSelection: Record<string, boolean>;
  selectedRowDataMap: Record<string, any>;
}

const initialState: IJobSelectionState = {
  rowSelection: {},
  selectedRowDataMap: {},
};

const jobSelectionSlice = createSlice({
  name: ReduxStore.jobSelection,
  initialState,
  reducers: {
    setRowSelectionState(state, action: PayloadAction<Record<string, boolean>>) {
      state.rowSelection = action.payload;
    },
    setSelectedRowDataMapState(state, action: PayloadAction<Record<string, any>>) {
      state.selectedRowDataMap = action.payload;
    },
    clearSelection(state) {
      state.rowSelection = {};
      state.selectedRowDataMap = {};
    },
    removeSelectedJobsState(state, action: PayloadAction<string[]>) {
      action.payload.forEach((jobId) => {
        delete state.rowSelection[jobId];
        delete state.selectedRowDataMap[jobId];
      });
    },
  },
});

export const { setRowSelectionState, setSelectedRowDataMapState, clearSelection, removeSelectedJobsState } =
  jobSelectionSlice.actions;
export default jobSelectionSlice.reducer;
